import React from 'react'
import { FSAppsButtons } from '@fs/zion-mobile-app-buttons'
import { css } from '@linaria/core'

// Safari is creating a huge amount of white space under the footer.
// I think safari is laying out all the links in a column at first creating the height.
// The height calculation of the elements with absolute positioning is not being resolved correctly without being wrapped with this position relative parent.
const safariCorrection = css`
  position: relative;
`

export default function AppBtns() {
  return (
    <div className={safariCorrection}>
      <FSAppsButtons light centered stacked={false} />
    </div>
  )
}
